import { useEffect, useLayoutEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, Result } from "antd";
import { useBuscarPorToken } from "../../../../Services/Domain/FInanceiro/TItulo/PagamentoServices";
import CarregamentoComponentes from "../../../../Components/Base/Carregamento";
import useScript from "../../../../Hooks/useScript";
import { EnumTituloSituacao } from "../../../../Models/Financeiro/Titulo/TituloSituacao";
import WebHttpErroResponse, { IWebHttpErroResponse } from "@/Models/Utils/Error/WebHttpErroResponse";

export default function GetNetView({
    
}) {
    const [queryString] = useSearchParams();
    const buttonClick = useRef<HTMLAnchorElement>(null);
    const navigate = useNavigate();

    function goBack() {
        //if (window.history.length === 1)
        window.close();
        // else
        //     navigate(-1);
    }

    const parametros = queryString
    .toString()
    .split('&')
    .reduce((acumulador, atual) => {
        const nome = atual.split('=')[0];
        const valor = atual.substring(nome.length + 1);
        
        acumulador[nome] = valor;

        return acumulador;
    }, {} as any);

    const identificador = Number.parseInt(parametros["identificador"] ?? '');
    const token = parametros["token"];
    const urlRedirectSucess = queryString.get("urlRedirectSucess") as string;

    const {
        data,
        isSuccess,
        isError,
        error,
        isPending  
    } = useBuscarPorToken({
        identificador,
        token : token ?? '',
        enabled : !isNaN(identificador) && identificador > 0 && typeof token === "string" && token.length > 0
    });

    const pagamento = typeof data?.data == "string" && (data?.data as string).length == 0 ? null : (data?.data ?? null);    
    const endereco = pagamento?.titulo?.devedor?.enderecos?.find(f => f) ?? null;
    const email = pagamento?.titulo?.devedor?.emails?.find(f => f) ?? null;
    const telefone = pagamento?.titulo?.devedor?.telefones?.find(f => f) ?? null;
    const nomeDevedor = ((pagamento?.titulo.devedor?.nomeSocial ?? pagamento?.titulo.devedor?.nome) ?? "")?.trim().length === 0 ? "Devedor" : (pagamento?.titulo.devedor?.nomeSocial ?? pagamento?.titulo.devedor?.nome);

    const formasPagamento = [/*"debito",*/ "credito-autenticado", "credito-nao-autenticado", "debito-autenticado", /*"debito-nao-autenticado",*/ "boleto", "qr-code" ];
    if ((pagamento?.titulo?.parcelas ?? 0) > 1) {
        formasPagamento.push("pix");
        formasPagamento.push("debito");
        formasPagamento.push("debito-nao-autenticado");
    }

    const isDev = (process.env.NODE_ENV === "development");

    const erroWeb = new WebHttpErroResponse().isInstancia(error) ? new WebHttpErroResponse(error as IWebHttpErroResponse) : undefined;

    useEffect(() => {
        if (isSuccess && pagamento?.linkPagamentoIntegrador !== null && pagamento?.linkPagamentoIntegrador !== undefined)
        {
            window.location.href = pagamento.linkPagamentoIntegrador.url;
        }
    }, [isSuccess, pagamento?.linkPagamentoIntegrador]);

    const {
        isSucesso : isSucessoLoadScript,
        isErro : isErroLoadScript,
        isCarregando
    } = useScript({
        habilitado : isSuccess && pagamento != null,
        url : /*isDev ? "https://checkout-homologacao.getnet.com.br/loader.js" : */"https://checkout.getnet.com.br/loader.js", 
        atributos : [
            { nome: "async", valor : "" },
            { nome: "data-getnet-sellerid", valor: /*isDev ? "c6cda032-d487-4616-9942-8ae23fea19bd" :  */"74c36689-fdff-409e-9dc0-6d5f214e9b6c"},
            { nome : "data-getnet-token", valor: `Bearer ${pagamento?.accessToken?.access_token}` },
            { nome : "data-getnet-amount", valor: pagamento?.titulo?.valorPrevisto.toFixed(2).toString() },
            { nome : "data-getnet-customerid", valor: pagamento?.titulo?.codDevedor },
            { nome : "data-getnet-orderid", valor: pagamento?.titulo?.codigo },
            { nome : "data-getnet-button-class", valor: "pay-button-getnet" },
            { nome : "data-getnet-installments", valor: pagamento?.titulo.parcelas },
            { nome : "data-getnet-customer-first-name", valor: pagamento?.titulo?.devedor?.nome?.split(' ').find(f => f) },
            { nome : "data-getnet-customer-last-name", valor: pagamento?.titulo?.devedor?.nome?.split(' ').splice(1).join(' ') },
            { nome : "data-getnet-customer-document-type", valor: (pagamento?.titulo?.devedor?.cpf ?? null) == null ? "CNPJ" : "CPF" },
            { nome : "data-getnet-customer-document-number", valor: (pagamento?.titulo?.devedor?.cpf ?? null) == null ? pagamento?.titulo?.devedor?.cnpj : pagamento?.titulo?.devedor?.cpf },
            { nome : "data-getnet-customer-email", valor: (email?.endereco ?? '').trim() },
            { nome : "data-getnet-customer-phone-number", valor: (telefone?.ddd ?? '').trim() + (telefone?.numero ?? '').trim() },
            { nome : "data-getnet-customer-address-street", valor: endereco?.logradouro },
            { nome : "data-getnet-customer-address-street-number", valor: endereco?.numero },
            { nome : "data-getnet-customer-address-complementary", valor: endereco?.complemento ?? '' },
            { nome : "data-getnet-customer-address-neighborhood", valor: endereco?.bairro },
            { nome : "data-getnet-customer-address-city", valor: endereco?.municipio?.nome },
            { nome : "data-getnet-customer-address-state", valor: endereco?.estado.sigla },
            { nome : "data-getnet-customer-address-zipcode", valor: (endereco?.cep ?? '').replace(/[^0-9]/g,'') },
            { nome : "data-getnet-customer-country", valor: "Brasil" },
            { nome : "data-getnet-items", valor : [
                {
                    "name": pagamento?.titulo?.origem?.tipo?.nome,
                    "description": pagamento?.titulo?.origem?.referencia?.nomeReferencia,
                    "value": pagamento?.titulo?.valorPrevisto.toFixed(2).toString(), 
                    "quantity": 1,
                    "sku": ""
                }
            ] },
            { nome : "data-getnet-url-callback", valor: "" },
            { nome : "data-getnet-pre-authorization-credit", valor: "" },
            { nome: "data-getnet-payment-methods-disabled", valor: JSON.stringify(formasPagamento) }
        ]
    });

    useLayoutEffect(() => {
        const elementoIFrame:HTMLIFrameElement|null = document.querySelector("#getnet-checkout");

        if (isSuccess && isSucessoLoadScript && elementoIFrame != null) {
            elementoIFrame.addEventListener('load', ev => { 
                window.addEventListener("message", function iframeMessage(e) {
                    const dataResponse = e.data || '';
                    const dataStatus:'success'|'close'|'error' = dataResponse.status || dataResponse;

                    switch (dataStatus) {
                        // Corfirmação positiva do checkout.
                        case 'success':
                            console.log('Transação realizada.');
                            window.location.replace(`${(urlRedirectSucess ?? '').trim() == '' ? '/Financeiro/Pagamento/Sucesso' : urlRedirectSucess}?identificador=${identificador}`);
                            break;
                    
                        // Notificação de que o IFrame de checkout foi fechado a aprovação.
                        case 'close':
                            console.log('Checkout fechado.'); 
                            goBack();                    
                            break; 
                    
                        // // Notificação que um boleto foi registrado com sucesso 
                        //  case 'pending': 
                        //     console.log('Boleto registrado e pendente de pagamento'); 
                        //     console.log(data.detail); 
                        //     break;      
                    
                        // Notificação que houve um erro na tentativa de pagamento 
                        case 'error': 
                            console.log('Checkout erro.'); 
                            //const dataErro:ErroGetNet = dataResponse.detail;
                            //this.alert("Erro : " + JSON.stringify(dataErro ?? ""));
                            break;
                    
                        // Ignora qualquer outra mensagem 
                        default:
                            break;
                    }
                });
            });
        }
    }, [isSuccess, isSucessoLoadScript]);


    useEffect(() => {
        if (isSuccess && isSucessoLoadScript && (pagamento?.linkPagamentoIntegrador === null || pagamento?.linkPagamentoIntegrador === undefined))
            buttonClick.current?.click();
    }, [isSuccess, isSucessoLoadScript, pagamento?.linkPagamentoIntegrador]);

    if (isPending || isCarregando)
        return <CarregamentoComponentes.TelaCarregamento />

    if (isSuccess && pagamento == null)
        return <Result
            status="warning"
            title="Título não foi encontrado!"
            extra={<Button type="primary" onClick={() => goBack()}>Voltar</Button>}
        />

    if (isSuccess && pagamento != null && pagamento.titulo.codSituacao !== EnumTituloSituacao.Pendente)
        return <Result
            status="info"
            title={`Título em questão encontra-se ${pagamento.titulo.situacao?.nome ?? "Aguardando Confirmacao"}, logo não é possível realizar o pagamento.`}
            extra={<Button type="primary" onClick={() => goBack()}>Voltar</Button>}
        />

    if (isErroLoadScript || isError) 
        return <Result
            status="404"
            title="404"
            subTitle={erroWeb?.type === "WebHttpErroResponse" ? erroWeb?.mensagem : "Erro ao carregar as informações do pagamento, verifique se o titulo informado existe e tente novamente!"}
            extra={<Button type="primary" onClick={() => goBack()}>Voltar</Button>}
        />

    if (isSuccess && endereco == null)
        return <Result
            status="warning"
            title={`Não foi possível encontrar o endereco do ${nomeDevedor}, logo não é possível realizar o pagamento.`}
            extra={<Button type="primary" onClick={() => goBack()}>Voltar</Button>}
        />

    if (isSuccess && (email == null || (email.endereco ?? "").trim().length == 0))
        return <Result
            status="warning"
            title={`Não foi possível encontrar o email do ${nomeDevedor}, logo não é possível realizar o pagamento.`}
            extra={<Button type="primary" onClick={() => goBack()}>Voltar</Button>}
        />
            
    // if (isSuccess && isSucessoLoadScript && (pagamento?.linkPagamentoIntegrador === null && pagamento?.linkPagamentoIntegrador === undefined))
    //     buttonClick.current?.click();

    return <a className="pay-button-getnet" ref={buttonClick}></a>;
}
type ErroGetNet = { 
    type:'credit',
    message:string 
}